module.exports = __webpack_public_path__ + "files/c410edc8964888f1aa6e285d4b81eeeb.png";